/**
 * @desc sendProcessEndEvent
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(data: defs.FlowProcessEndEvent): Promise<any> {
  return defHttp.post({
    url: '/flow/process/end/event',
    data,
  });
}

export function mock(data: defs.FlowProcessEndEvent): Promise<any> {
  return defHttp.post({
    url: '/mock/flow/process/end/event',
    data,
  });
}
